import React from "react";
import trans from "../../../../utils";
import { formatDate } from "../../../../JsHelpers/DateFormat";

export default function TrackedSelectedParameters({ item, name, type }) {
	const getFormattedDate = (serverTime) => formatDate(serverTime);
	const { formattedDate, formattedTime } = getFormattedDate(item);
	return (
		<div className="flex-between display-border p-8">
			<div className="parameter-title">{trans(name)}</div>
			{!type ? (
				<div>{item}</div>
			) : (
				<div>{formattedDate + " " + formattedTime}</div>
			)}
		</div>
	);
}
